<div class="row">
  <div class="container_tab_nav">
    <ul class="nav nav-tabs two">
      <li
        [style.width.%]="50"
        (click)="setTab(tabs.LIST)"
        class="{{currentTab === tabs.LIST ? 'active' : 'inactive'}}"
      >
        <a>Lista adempimenti inseriti</a>
      </li>
      <li
        [style.width.%]="50"
        (click)="setTab(tabs.CREATE)"
        class="{{currentTab === tabs.CREATE ? 'active' : 'inactive'}}"
      >
        <a>Crea nuovo adempimento</a>
      </li>
    </ul>
  </div>
  <div class="tab-content">
    <div *ngIf="currentTab == tabs.LIST">
      <app-step-adempimenti-list></app-step-adempimenti-list>
    </div>
    <div *ngIf="currentTab == tabs.CREATE">
      <app-step-adempimenti-form
        (adempimentoChange)="onEmitAdempimentoSubmit($event)"
      ></app-step-adempimenti-form>
    </div>
  </div>
</div>


<div class="row wizard-buttons">
  <p class="col-sm-3 col-xs-6">
    <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset()">Reset</button>
  </p>
  <p
    class="col-sm-3 col-xs-6 col-sm-offset-6">
    <button type='button' class='btn btn-primary btn-block' (click)="salva()">
      Prosegui
    </button>
  </p>
</div>
